var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircleWithChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9451,
    cy: 13.9451,
    r: 13.9451,
    fill: "#4BCD5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.547 11.133C19.7921 11.3781 19.7921 11.7754 19.547 12.0205L13.6901 17.8774C13.445 18.1225 13.0477 18.1225 12.8026 17.8774L9.45577 14.5306C9.21071 14.2855 9.21071 13.8882 9.45577 13.6431C9.70084 13.3981 10.0982 13.3981 10.3432 13.6431L13.2463 16.5462L18.6595 11.133C18.9046 10.888 19.3019 10.888 19.547 11.133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleWithChecked);
export default __webpack_public_path__ + "static/media/GreenCircleWithChecked.96c717b5f79f2cc30b53d6d32922cbf9.svg";
export { ForwardRef as ReactComponent };